import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, map, mergeMap, Observable, of, throwError } from "rxjs";
import { fetchAuthSession, AuthSession, JWT } from '@aws-amplify/auth';
import { ErrorDialogComponent } from "../app/secure/_components/error-dialog/error-dialog.component";
import { MatDialog } from "@angular/material/dialog";

const getToken = (): Observable<JWT | undefined | null> => {
  return from(fetchAuthSession()).pipe(
    map((session: AuthSession) => {
      return session.tokens?.idToken;
    }),
    catchError(() => {
      return of(null);
    }),
  );
};

@Injectable()


export class AuthInterceptor implements HttpInterceptor {

  message!: string;

  constructor(private dialog: MatDialog) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return getToken().pipe(
      mergeMap((token) => {
        if (token) {
          // Clone the request with the Authorization header
          const cloned = req.clone({
            headers: req.headers.set('Authorization', token.toString())
              // .set('Access-Control-Allow-Origin', '*')
              // .set('Access-Control-Allow-Headers', '*')
              // .set('Access-Control-Allow-Methods', '*')
              .set('Content-Type', 'application/json'),
          });
          return next.handle(cloned);
        } else {
          // Handle the request without an Authorization header if no token is available
          return next.handle(req);
        }
      }),
      catchError((error) => {
        // if (error.status === 401) {
        //   this.message = 'You are not authorized to perform this action.';
        // } else if (error.status === 500) {
        //   this.message = 'Internal server error';
        // }
        // if (this.message) {
        //   this.dialog.open(ErrorDialogComponent, {
        //     data: { message: this.message },
        //   });
        // }
        console.error('Interceptor error:', error);
        return throwError(() => error);
      }),
    );
  }


}
